import { Alert, AlertTitle, Box, Button, Typography } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

export type InvoiceAlert = {
    title: string;
    lines: Array<string>;
};

type InvoiceAlertDialogProps = {
    alerts: Array<InvoiceAlert>;
    onConfirm: () => void;
    onCancel: () => void;
};

export const InvoiceAlertDialog = ({ alerts, onConfirm, onCancel }: InvoiceAlertDialogProps) => {
    return (
        <Box sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            p: 4,
            pt: 2,
        }}>
            <Box sx={{ mb: 3 }}>
                <WarningAmberIcon sx={{ fontSize: 72, color: "warning.main" }} />
            </Box>

            <Typography variant="h5" sx={{ fontWeight: 600, mb: 1, textAlign: "center" }}>
                Atenção!
            </Typography>

            <Typography variant="body1" sx={{ mb: 3, color: "text.secondary", textAlign: "center" }}>
                Reveja os seguintes alertas antes de continuar.
            </Typography>

            <Box sx={{ display: "flex", flexDirection: "column", gap: 2, width: "100%", mb: 4 }}>
                {alerts.map((alert) => (
                    <Alert key={alert.title} severity="warning">
                        <AlertTitle sx={{ fontWeight: 700 }}>{alert.title}</AlertTitle>
                        {alert.lines.map((line, lineIndex) => (
                            <Box key={`${alert.title}-${lineIndex}`} sx={{ mt: lineIndex === 0 ? 0 : 0.5 }}>
                                {line}
                            </Box>
                        ))}
                    </Alert>
                ))}
            </Box>

            <Box sx={{ display: "flex", justifyContent: "center", gap: 3, width: "100%" }}>
                <Button
                    onClick={onCancel}
                    variant="outlined"
                    color="primary"
                    size="large"
                    sx={{ minWidth: 180, py: 1.5 }}
                >
                    Cancelar
                </Button>
                <Button
                    onClick={onConfirm}
                    variant="contained"
                    color="primary"
                    size="large"
                    sx={{ minWidth: 180, py: 1.5 }}
                >
                    Tirar a fatura
                </Button>
            </Box>
        </Box>
    );
};
